import NoData from '@/components/NoData';
import styles from './index.less';
import { List, PullRefresh } from 'react-vant';
import { history, useModel } from '@umijs/max';
import { useRef, useState } from 'react';
import { getWechatNotice } from '@/service/banner';
import { EyeO } from '@react-vant/icons';

const Notice = () => {
  const [WechatNoticeList, setWechatNoticeList] = useState([]);
  const pageNum = useRef(1);
  const {defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );

  const click = (item: any) => {
    // console.log(item);
    history.push(`/noticeDetail?sequenceNbr=${item.sequenceNbr}`);
  };

  const [finished, setFinished] = useState<boolean>(false);

  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWechatNoticeList([]);
    const data = await getWechatNotice({
      pageNum: pageNum.current,
      pageSize: 10,
      status: '1',
      type: '1',
      communityId: defaultRoom?.communityId 
    }).catch(() => {
      setFinished(true);
    });
    const listData: any = [...WechatNoticeList, ...data.rows];
    if (isRefresh) {
      setWechatNoticeList(data.rows);
    } else {
      setWechatNoticeList(listData);
    }

    if (data.rows.length < 10 || !data.rows.length || data.total === 0) {
      // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1;
      setFinished(false); // 仍有数据可加载，保持为false
    }
  };

  const onRefresh = async () => {
    pageNum.current = 1;
    setFinished(true);
    setWechatNoticeList([]);
    onLoadRefresh(true);
  };

  return (
    <div className={styles.notice}>
      <PullRefresh onRefresh={onRefresh} headHeight={80}>
        <List
          finished={finished}
          onLoad={onLoadRefresh}
          finishedText={!WechatNoticeList?.length ? '' : '没有更多了'}
        >
          {WechatNoticeList?.length !== 0 ? (
            <>
              {WechatNoticeList.map((item: any) => (
                <div
                  onClick={() => click(item)}
                  className={styles['contentBox']}
                  key={item.sequenceNbr}
                >
                  <div className={styles.title}>{item.title}</div>
                  <div>
                    <strong>简介：</strong>
                    {item.description}
                  </div>
                  <div className={styles.box}>
                    <div className={styles['viewBox']}>
                      <div>{item.publishTime ? item.publishTime : '-'}</div>
                      <div className={styles.boxs}>
                        <EyeO className={styles.icon} />
                        {item.viewCount ? item.viewCount : 0}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <NoData />
          )}
        </List>
      </PullRefresh>
    </div>
  );
};

export default Notice;
